var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiStatusMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#A174FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.19 6.94a1.5 1.5 0 011.06-.44H20A1.5 1.5 0 0121.5 8v7.5a.75.75 0 01-1.28.53L18.19 14h-4.94a1.5 1.5 0 01-1.5-1.5V8c0-.398.158-.78.44-1.06zM20 8h-6.75v4.5h5.25a.75.75 0 01.53.22l.97.97V8zM6.94 12.19A1.5 1.5 0 018 11.75h1.5a.75.75 0 010 1.5H8v5.69l.97-.97a.75.75 0 01.53-.22h5.25v-1.5a.75.75 0 011.5 0v1.5a1.5 1.5 0 01-1.5 1.5H9.81l-2.03 2.03a.75.75 0 01-1.28-.53v-7.5c0-.398.158-.78.44-1.06z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--status-message-b066fda2ea5ca8167263235e3d129695.svg";
export { SvgIconUiStatusMessage as Component };